import { Injectable } from '@angular/core';
import { UIThemeEnum } from '../models/ui.models';
import { environment } from 'src/environments/environment';
import { AvailableLangs, TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { selectCurrentUserProfile, selectCurrentUserProfileProcess } from '../store/_features/profile/profile.selector';
import { UserProfile } from '../models/base.models';
import { CurrentProfileActions } from '../store/_features/profile/profile.actions';


@Injectable({
  providedIn: 'root'
})
export class SharedProfileService {
  isProfileLoaded: boolean = false;
  currentUser: UserProfile
constructor(private store: Store) {
  this.store.dispatch(CurrentProfileActions.load());
  this.store.select(selectCurrentUserProfile).subscribe(profile => {
      this.currentUser = profile
  })

  this.store.select(selectCurrentUserProfileProcess).subscribe(process => {
      this.isProfileLoaded = process.status == 'done'
      
  })
}

}
